import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Price, PriceKind } from '@product/const';

@Component({
  selector: 'sd-product-price-transit',
  standalone: true,
  templateUrl: './product-price-transit.component.html',
  styleUrls: ['./product-price-transit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductPriceTransitComponent {
  @Input() prices: Price[];
  @Input() transitState: boolean;
  @Input() isNotAvailable: boolean;
  @Input() hidePersonalTitle = false;

  @Output() switchPrice = new EventEmitter<boolean>();

  get regularPrice(): Price | undefined {
    return this.prices.find(({ kind }) => kind === PriceKind.REGULAR);
  }

  get crossedPrice(): Price | undefined {
    return this.prices.find(({ kind }) => kind === PriceKind.CROSSED);
  }

  get personalPrice(): Price | undefined {
    const personalPrice = this.prices.find(({ kind }) => kind === PriceKind.PERSONAL);

    if (!personalPrice || !personalPrice.value) {
      return undefined;
    }

    const regularPrice = this.regularPrice;

    if (regularPrice && regularPrice.value && personalPrice.value < regularPrice.value) {
      return personalPrice;
    }

    return undefined;
  }

  get transitPrice(): Price | undefined {
    return this.prices.find(({ kind }) => kind === PriceKind.TRANSIT);
  }

  get mainPrice(): Price | undefined {
    if (this.personalPrice) {
      return this.personalPrice;
    }

    return this.regularPrice;
  }

  get hasDiscount(): boolean {
    if (this.transitState || this.personalPrice) {
      return false;
    }

    return !!(this.crossedPrice && this.regularPrice && this.crossedPrice.value > this.regularPrice.value);
  }

  get showPersonalTitle(): boolean {
    return !this.hidePersonalTitle && !!this.personalPrice && !this.transitState;
  }

  onSwitchPrice(flag: boolean): void {
    this.switchPrice.emit(flag);
  }
}
